import type { PartialDeep } from 'type-fest';
import { Configuration } from '../defaultConfig';

const chainStageConfig: Record<string, PartialDeep<Configuration>> = {
  preprod: {
    services: {
      validation: {
        authEndpoint: 'https://dev.api.civic.com/sign-preprod', // lambda
      },
    },
  },
  prod: {
    services: {
      validation: {
        authEndpoint: 'https://api.civic.com/sign', // lambda
      },
    },
  },
};

export default chainStageConfig;
